/**
 * SenderIdManagementService
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { SenderIdRequestStatus } from './senderIdRequestStatus';

export interface SenderRequestRouteModel { 
    id?: string;
    routeName?: string;
    senderIdRequestID?: string;
    aggregatorID?: string;
    priority?: number;
    mnc?: string;
    mcc?: string;
    serviceproviderID?: string;
    routeID?: string;
    deleted?: boolean;
    status?: SenderIdRequestStatus;
    tenantId?: string;
    readonly telco?: string;
}